export enum EModalOkType {
  Error,
  Warning,
  Info,
  Success,
}